import React from 'react';
import { DividerModel, ModuleModel } from 'models/MenuItem';
import {
    DirectionsCar,
    People,
    Dashboard as DashboardIcon,
    Business,
    EmojiTransportation,
    DirectionsBoat,
    CalendarMonth,
    DepartureBoard,
    Description,
    Mail,
    ThreeP,
    RvHookup,
} from '@mui/icons-material';
import Chats from 'modules/chats/Chats';
import Dashboard from 'modules/dashboard/Dashboard';
import CarsByStatus from 'modules/cars/CarsByStatus';
import CarsByParty from 'modules/cars/CarsByParty';
import Cars from 'modules/cars/Cars';
import Car from 'modules/cars/Car';
import CarLists from 'modules/carLists/CarLists';
import Companies from 'modules/companies/Companies';
import Users from 'modules/users/Users';
import Account from 'modules/settings/Account';
import Settings from 'modules/settings/Settings';
import Yards from 'modules/yards/Yards';
import Vessels from 'modules/vessels/Vessels';
import Voyages from 'modules/voyages/Voyages';
import Voyage from 'modules/voyages/Voyage';
import Finances from 'modules/voyages/Finances';
import BLTypes from 'modules/voyages/BLTypes';
import BL from 'modules/voyages/BL';
import Invoices from 'modules/invoices/Invoices';
import Invoice from 'modules/invoices/Invoice';
import InvoiceCreate from 'modules/invoices/InvoiceCreate';
import Mailings from 'modules/mailings/Mailings';
import Parties from 'modules/parties/Parties';
import Permissions from 'modules/permissions/Permissions';
import Transportation from 'modules/transportation/Transportation';


const modules: (ModuleModel | DividerModel)[] = [
    {
        title: 'dashboard',
        path: '/',
        module: Dashboard,
        icon: <DashboardIcon/>,
    },
    {
        title: 'cars',
        path: '/cars/pending',
        module: Cars,
        icon: <DirectionsCar/>,
        permission: 'cars view',
    },
    {
        title: 'voyages',
        path: '/voyages',
        module: Voyages,
        icon: <CalendarMonth/>,
        permission: 'voyages view',
    },
    {
        title: 'ports_and_yards',
        path: '/yards',
        module: Yards,
        icon: <EmojiTransportation/>,
        permission: 'ports view',
    },
    {
        title: 'vessels',
        path: '/vessels',
        module: Vessels,
        icon: <DirectionsBoat/>,
        permission: 'vessels view',
    },
    {
        title: 'transportation',
        path: '/transportation',
        module: Transportation,
        icon: <RvHookup/>,
        permission: 'transportations view',
    },
    {
        divider: 1,
    },
    {
        title: 'car_history',
        path: '/cars/ready',
        module: CarsByStatus,
        icon: <DepartureBoard/>,
        permission: 'cars view history',
        subPages: [
            '/cars/shipped',
            '/cars/received',
            '/cars/canceled',
            '/cars/lost',
        ],
    },
    {
        title: 'invoices',
        path: '/invoices',
        module: Invoices,
        icon: <Description/>,
        permission: 'invoices view',
    },
    {
        title: 'parties',
        path: '/parties',
        module: Parties,
        icon: <ThreeP/>,
        permission: 'parties view',
    },
    {
        divider: 2,
    },
    {
        title: 'mailings',
        path: '/mailings',
        module: Mailings,
        icon: <Mail/>,
        permission: 'mail send',
    },
    {
        title: 'companies',
        path: '/companies/shippers',
        module: Companies,
        icon: <Business/>,
        permission: 'companies view',
    },
    {
        title: 'users',
        path: '/users',
        module: Users,
        icon: <People/>,
        permission: 'users view',
    },
    {
        divider: 3,
    },
    {
        path: '/account/*',
        module: Account,
    },
    {
        path: '/cars/party/:id',
        module: CarsByParty,
        permission: 'cars view',
    },
    {
        path: '/cars/:status',
        module: CarsByStatus,
        permission: 'cars view history',
    },
    {
        path: '/companies/:status',
        module: Companies,
        permission: 'companies view',
    },
    {
        path: '/cars/export-list',
        module: CarLists,
        permission: 'cars list export',
    },
    {
        path: '/car/:id',
        module: Car,
    },
    {
        path: '/voyage/:id',
        module: Voyage,
        permission: 'voyages view',
    },
    {
        path: '/voyage/:id/finances',
        module: Finances,
        permission: 'cars manage',
    },
    {
        path: '/voyage/:id/bl',
        module: BL,
        permission: 'cars manage',
    },
    {
        path: '/invoice/new',
        module: InvoiceCreate,
        permission: 'invoices create',
    },
    {
        path: '/invoice/:id',
        module: Invoice,
        permission: 'invoices view',
    },
    {
        path: '/settings',
        module: Settings,
        permission: 'settings update',
    },
    {
        path: '/users/permissions',
        module: Permissions,
        permission: 'users permissions',
    },
    {
        path: '/bl/types',
        module: BLTypes,
        permission: 'cars manage',
    },
    {
        path: '/chats',
        module: Chats,
    },
];

export default modules;
